var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOutLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8333333,15.8333333 L4.16666667,15.8333333 L4.16666667,4.16666667 L10,4.16666667 L10,2.5 L4.16666667,2.5 C3.24166667,2.5 2.5,3.25 2.5,4.16666667 L2.5,15.8333333 C2.5,16.75 3.24166667,17.5 4.16666667,17.5 L15.8333333,17.5 C16.75,17.5 17.5,16.75 17.5,15.8333333 L17.5,10 L15.8333333,10 L15.8333333,15.8333333 Z M11.6666667,2.5 L11.6666667,4.16666667 L14.6583333,4.16666667 L6.46666667,12.3583333 L7.64166667,13.5333333 L15.8333333,5.34166667 L15.8333333,8.33333333 L17.5,8.33333333 L17.5,2.5 L11.6666667,2.5 Z",
    id: "\\u5F62\\u72B6",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutLink);
export default __webpack_public_path__ + "static/media/out_link.142070d0fdda2fb04fea5c31d3bc41bd.svg";
export { ForwardRef as ReactComponent };